import { render, staticRenderFns } from "./BillsOfWholesaler.vue?vue&type=template&id=2e18b5af"
import script from "./BillsOfWholesaler.vue?vue&type=script&lang=js"
export * from "./BillsOfWholesaler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports